export default "__VITE_ASSET__CVDj7I3X__"